/**
 * 预览超时监控器，超时时间为一分钟
 */
export default class PreviewTimer {
  constructor () {
    // 超时时间为一分钟
    this._mistiming = 60 * 1000
    this._canceled = false
  }

  static createTimer () {
    return new PreviewTimer()
  }

  start () {
    let that = this
    return new Promise((resolve, reject) => {
      that._timer = setTimeout(resolve, that._mistiming, that._canceled)
    })
  }

  cancel () {
    this._canceled = true
    clearTimeout(this._timer)
  }
}
